import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastsContainer } from './toasts-container.component';
import { ToastService } from './toast.service';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [],
  imports: [CommonModule, NgbToastModule, ToastsContainer],
  providers: [ToastService],
  exports: [ToastsContainer],
})
export class ToastModule {
  constructor() {}
}
